//Call_[npm_run_updateTestIndexes]_to_update_this_file.

// @create-index

module.exports = {
    blocks: require('./blocks'),
    embedInSubMenu: require('./embedInSubMenu'),
    embedInUseCase: require('./embedInUseCase'),
    findHNode: require('./findHNode'),
    namespacesToMethodAccess: require('./namespacesToMethodAccess'),
    testTree: require('./testTree'),
    testWorkspace: require('./testWorkspace'),
};


